


























































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component, Prop } from 'vue-property-decorator'
import { APIReportCategory } from '@/models/api/report-category.model'
import { APIReportDatasource } from '../../../models/api/report-datasource.model'
import { APIReportChartType } from '@/models/api/report-chart-type.model'
import { APIRole } from '@/models/api/role.model'

@Component
export default class ReportFilters extends Vue {
    @Prop() eventFilters!: any

    buttonLoading = false
    formValid = false
    isAdmin = false

    formData: {[key: string]: any} = {
        reportId: null,
        reportName: null,
        categoryId: null,
        datasourceId: null,
        chartTypeId: null,
        roles: null
    }

    formModel: { categories: APIReportCategory[]; datasources: APIReportDatasource[]; chartTypes: APIReportChartType[]; roles: APIRole[]} = {
        categories: [],
        datasources: [],
        chartTypes: [],
        roles: []
    }

    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        numberRule: [
            (v: string) => /^\d+$/.test(v) || 'only accept numbers'
        ]
    }

    get userData () {
        return this.$store.state.AuthStore.auth.user
    }

    validateForm () {
        if (Object.keys(this.formData).length > 0) {
            this.$emit('loadFilters', this.formData)
        }
    }

    resetFilters () {
        this.formData.reportId = null
        this.formData.reportName = null
        this.formData.categoryId = null
        this.formData.datasourceId = null
        this.formData.chartTypeId = null
        this.formData.roles = null
        this.$emit('resetFilters')
    }

    getCategories () {
        return new Promise(resolve => {
            this.$store.dispatch('getReportCategoriesFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.categories = this.$store.state?.FiltersStore?.reportCategoriesFilter?.map((p: APIReportCategory) => {
                            return {
                                text: p.categoryName,
                                value: p.categoryId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getDatasources () {
        return new Promise(resolve => {
            this.$store.dispatch('getReporDatasourcesFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.datasources = this.$store.state?.FiltersStore?.reporDatasourcesFilter?.map((p: APIReportDatasource) => {
                            return {
                                text: p.datasourceName,
                                value: p.datasourceId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getReporChartTypes () {
        return new Promise(resolve => {
            this.$store.dispatch('getReporChartTypesFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.chartTypes = this.$store.state?.FiltersStore?.reporChartTypesFilter?.map((p: APIReportChartType) => {
                            return {
                                text: p.chartTypeName,
                                value: p.chartTypeId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getRoles () {
        return new Promise(resolve => {
            const user = JSON.parse(JSON.stringify(this.userData))
            this.isAdmin = user.roles?.filter((x: APIRole) => {
                return x.roleId === 1
            })
            if (this.isAdmin) {
                this.$store.dispatch('getRoles')
                    .then(resp => {
                        if (resp?.status === 200) {
                            this.formModel.roles = this.$store.state.RolesStore.roles.map((p: APIRole) => {
                                return {
                                    text: p.roleName,
                                    value: p.roleId
                                }
                            })
                            resolve()
                        }
                    })
                // const userRole = user.roles.map((item: APIRole) => {
                //     return item.roleId
                // })
                // this.formData.roles.push()
            }
        })
    }

    async mounted () {
        this.$store.dispatch('getUserLogued')
        this.formData = this.eventFilters
        await this.getCategories()
        await this.getDatasources()
        await this.getReporChartTypes()
        // await this.getRoles()
    }
}
